import LoginPage from "./LoginPage";
import AccessDenied from "./AccessDenied";
import NotFound from "./NotFound";
import RegisterPage from "./RegisterPage";
import RequestResetPasswordPage from "./RequestResetPasswordPage";
import ResetPasswordPage from "./ResetPasswordPage";
import VerifyEmailAddressToken from "./VerifyEmailAddressToken";

const guestRoutes = [
  {
    path: "",
    // element: <BeforeLoginGuard />,
    children: [
      {
        path: "/login",
        element: <LoginPage />,
        title: "Login",
      },
      {
        path: "/register",
        element: <RegisterPage />,
        title: "Register",
      },
      {
        path: "/forgot-password",
        element: <RequestResetPasswordPage />,
        title: "Reset Password",
      },
      {
        path: "/forgot-password/token/:token",
        element: <ResetPasswordPage />,
        title: "Reset Password",
      },
      {
        path: "/access-denied",
        element: <AccessDenied />,
        title: "Access Denied",
      },
      {
        path: "/verify-email/token/:token",
        element: <VerifyEmailAddressToken />,
        title: "Verify Token",
      },
      {
        path: "/notfound",
        element: <NotFound />,
        title: "Not Found",
      },
    ],
  },
];

export default guestRoutes;
